import {createSubmitRequestTypes} from "./helpers";

export const REQUEST_START_SERVICE = "INFRASTRUCTURE:REQUEST_START_SERVICE";
export const START_SERVICE = createSubmitRequestTypes("INFRASTRUCTURE:START_SERVICE");
export const requestStartService = (serviceId) => ({ type: REQUEST_START_SERVICE, serviceId });
export const cancelStartService = () => ({ type: START_SERVICE.CANCEL });

export const REQUEST_STOP_SERVICE = "INFRASTRUCTURE:REQUEST_STOP_SERVICE";
export const STOP_SERVICE = createSubmitRequestTypes("INFRASTRUCTURE:STOP_SERVICE");
export const requestStopService = (serviceId) => ({ type: REQUEST_STOP_SERVICE, serviceId });
export const cancelStopService = () => ({ type: STOP_SERVICE.CANCEL });

export const REQUEST_RUN_SERVICE = "INFRASTRUCTURE:REQUEST_RUN_SERVICE";
export const RUN_SERVICE = createSubmitRequestTypes("INFRASTRUCTURE:RUN_SERVICE");
export const requestRunService = (serviceId) => ({ type: REQUEST_RUN_SERVICE, serviceId });
export const cancelRunService = () => ({ type: RUN_SERVICE.CANCEL });
